import { ITask } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxActions } from '../state';
import { setCallToCompleted } from '../callHandlers/callStateHandler';

function handleTaskComplete(
  context: InboxContext,
  task: ITask,
  classified: boolean,
): void {
  inboxActions.restorePrevSelectedTaskId();

  setCallToCompleted(context, task.id, classified);
}

export default handleTaskComplete;
